import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Grid,
  Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  BooleanInput,
  CheckboxGroupInput,
  RadioButtonGroupInput,
  useRecordContext,
} from "react-admin";
import YesNoInput from "../unit/YesNoInput";
import React from "react";

const Permission = ({ ...props }) => {
  const record = useRecordContext(props);
  const permission = record?.bbPermission.toString();
  let allPermission = {};
  if (record?.bankaccess == "full") {
    allPermission = {
      Personal: {
        permissionItems: {
          personal_applications: "Applications",
          personal_loans: "Loans",
          personal_ach_payments: "ACH Payments",
          personal_customers: "Customers",
          personal_products: "Products",
          personal_partners: "Partners",
          personal_campaigns: "Campaigns",
          personal_reports: "Reports",
          personal_refills: "Refills",
        },
      },
      //removed it for now
      // Business: {
      //   permissionItems: {
      //     business_applications: "Applications",
      //     business_loans: "Loans",
      //     business_ach_payments: "ACH Payments",
      //     business_customers: "Customers",
      //     business_products: "Products",
      //     business_partners: "Partners",
      //     business_campaigns: "Campaigns",
      //     business_reports: "Reports",
      //   },
      // },
    };
  } else if (record?.bankaccess == "personal") {
    allPermission = {
      Personal: {
        permissionItems: {
          personal_applications: "Applications",
          personal_loans: "Loans",
          personal_ach_payments: "ACH Payments",
          personal_customers: "Customers",
          personal_products: "Products",
          personal_partners: "Partners",
          personal_campaigns: "Campaigns",
          personal_reports: "Reports",
        },
      },
    };
  } else if (record?.bankaccess == "business") {
    allPermission = {
      Business: {
        permissionItems: {
          business_applications: "Applications",
          business_loans: "Loans",
          business_ach_payments: "ACH Payments",
          business_customers: "Customers",
          business_products: "Products",
          business_partners: "Partners",
          business_campaigns: "Campaigns",
          business_reports: "Reports",
        },
      },
    };
  }

  const PermissionCheckbox = ({ name, value, checked }) => {
    const [isChecked, setIsChecked] = React.useState(checked);

    const handleChange = (event) => {
      setIsChecked(event.target.checked);
    };

    return (
      <Checkbox
        name={name}
        value={value}
        checked={isChecked}
        onChange={handleChange}
      />
    );
  };
  const PermissionBox = ({ ...props }) => {
    const index1 = props.index1;
    const data = props.data;

    const handleSelectAll = () => {};
    return (
      <Box key={index1}>
        <Grid container>
          {Object.keys(data).map((key2, index2) => {
            return (
              <Grid item xs={4} key={index2}>
                {/* <Checkbox
                  name={`${key2}`}
                  value={key2}
                  checked={permission.includes(key2)}
                />{" "}
                {data[key2]} */}
                <PermissionCheckbox
                  name={`${key2}`}
                  value={key2}
                  checked={permission.includes(key2)}
                />
                {data[key2]}
              </Grid>
            );
          })}
        </Grid>
      </Box>
    );
  };
  return (
    <>
      {Object.keys(allPermission).map((key, index) => {
        return (
          <Accordion
            key={key}
            defaultExpanded={false}
            sx={{ border: "1px solid #ddd", borderRadius: "0px" }}
            expanded={true}
          >
            <AccordionSummary
              sx={{ border: "1px solid #ddd", borderRadius: "0px" }}
              expandIcon={<ExpandMoreIcon />}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                {key == "Personal" ? "Consumer" : key}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{ border: "1px solid #ddd", borderRadius: "0px" }}
            >
              {Object.keys(allPermission[key]).map((key1, index1) => {
                return (
                  <>
                    <PermissionBox
                      index1={index1}
                      key1={key1}
                      id={key}
                      data={allPermission[key][key1]}
                    />
                  </>
                );
              })}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default Permission;
